// extracted by mini-css-extract-plugin
module.exports = {"position":"Position_position__3fk-_","codeContainer":"Position_codeContainer__2UKtf","copy":"Position_copy__1iGpm"};